// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"7e671912","115":"b55d70af","255":"77a50041","621":"960e27dc","636":"38b25c5a","832":"6ca335c9","881":"382f7063","885":"79ef8810","954":"95108dc6"}[chunkId] + ".chunk.js";
};